import { ButtonIcon, FocusTarget } from 'ui/components/primitives';
import { styled, theme } from 'ui/theme';

const Button = styled(ButtonIcon)`
  align-items: center;
  height: 100%;
`;

export const Search = {
  ButtonSearch: styled(Button)`
    color: ${theme.colors.action.navigation.standard.static};
  `,
  ButtonClear: styled(Button)`
    color: ${theme.colors.build.mediumLight1};
  `,

  Form: styled('form')`
    height: 100%;
    width: 100%;
  `,

  FocusTarget: styled(FocusTarget)`
    height: 100%;
    width: 100%;
  `,
};
